import { GroupedVirtualizedListItem } from "../../components/grouped-virtualized-list/GroupedVirtualizedList";
import i18n from "../../services/localization-service/i18n";
import { ISummaryGroupedObjectsDTO, ISummaryObjectsDTO, ISummarySetPointDTO } from "../../services/setpoint-administration-service/Models";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { ActionMenuItem, BaseActions } from "../../components/action-menu/ActionMenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faListCheck } from "@elynx/free-solid-svg-icons";

export enum SetPointGrouping {

    AllAlarms = 0,
    DeviceAlarms = 1,
    TankAlarms = 2,
    TankBatteryAlarms = 3,
    WellAlarms = 4,
    ObjectsWithoutAlarms = 5,
    SetPointsWithoutObjects = 6
}

export enum SetPointListActionEnum {
    Edit = 'edit',
    Copy = 'copy',
    Delete = 'delete',
    DisableTest = 'disable',
    Select = 'select',
    SelectAll = 'selectall',
    RemoveAll = 'removeall',
    Rename = 'rename',
}

export type SetPointListActionItem = {
    action: SetPointListActionEnum | BaseActions
} & ActionMenuItem;


export const contextActionItems: SetPointListActionItem[] = [{
    label: i18n.t("buttons.selectAll"),
    icon: () => <FontAwesomeIcon icon={faListCheck} size="xs" />,
    action: SetPointListActionEnum.SelectAll,
    order: 0
},{
    label: i18n.t("buttons.clearAll"),
    icon: () => <FontAwesomeIcon icon={faList} size="xs" />,
    action: SetPointListActionEnum.RemoveAll,
    order: 1
}];


export type Setpoint = ISummarySetPointDTO & GroupedVirtualizedListItem<string>;
export type ObjectNoSetpoint = IeLynxObject & GroupedVirtualizedListItem<string>;


export type SetpointGroupingOption = {
    text: string,
    value: SetPointGrouping
};

const setpointGroupingOptions: SetpointGroupingOption[] = [{
    text: i18n.t("setpointAdmin.groupingOptions.allAlarms"),
    value: SetPointGrouping.AllAlarms
}, {
    text: i18n.t("setpointAdmin.groupingOptions.deviceAlarms"),
    value: SetPointGrouping.DeviceAlarms
}, {
    text: i18n.t("setpointAdmin.groupingOptions.tankAlarms"),
    value: SetPointGrouping.TankAlarms
}, {
    text: i18n.t("setpointAdmin.groupingOptions.tankBatteryAlarms"),
    value: SetPointGrouping.TankBatteryAlarms
}, {
    text: i18n.t("setpointAdmin.groupingOptions.wellAlarms"),
    value: SetPointGrouping.WellAlarms
}, {
    text: i18n.t("setpointAdmin.groupingOptions.objectsWithoutAlarms"),
    value: SetPointGrouping.ObjectsWithoutAlarms
}, {
    text: i18n.t("setpointAdmin.groupingOptions.setPointsWithoutObjects"),
    value: SetPointGrouping.SetPointsWithoutObjects
}];


const AdminSetpointListUtils = {

    getGroupedData: function(model: ISummaryGroupedObjectsDTO | undefined, filterText: string): Setpoint[] {

        let setpoints: Setpoint[] = [];

        model && model.objectSetPoints
        .filter(o => o.setPointObject.displayText?.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 || filterText === '')
        .forEach(o => {
            const grouped = o.setPoints
                //.filter(v => v.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 || filterText === '')
                .map(v => {
                const item = {...v,
                    groupKey: o.setPointObject.displayText ?? ''
                } as Setpoint;

                return item;
            });

            setpoints = setpoints.concat(grouped);
        });


        model && model.objectSetPoints
        .forEach(o => {
            const grouped = o.setPoints
                .filter(v => v.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 || filterText === '')
                .map(v => {
                const item = {...v,
                    groupKey: o.setPointObject.displayText ?? ''
                } as Setpoint;

                return item;
            });

            setpoints = setpoints.concat(grouped);
        });


        setpoints = setpoints.sort((a, b) => (a.groupKey.toLocaleLowerCase()).localeCompare(b.groupKey.toLocaleLowerCase()));
        
        return setpoints;
    },

    getNoSetpointData: function(model: ISummaryObjectsDTO | undefined, filterText: string): ObjectNoSetpoint[] {
        let data: ObjectNoSetpoint[] = [];

        model && model.objects
        .filter(o => o.displayText?.toLowerCase().indexOf(filterText.toLowerCase()) !== -1 || filterText === '')
        .forEach(o => {
            const item = {...o,
                groupKey: i18n.t('setpointAdmin.objectsNoSetpoints', {objectType: getObjectTypeName(o.objectType, true)})
            } as ObjectNoSetpoint;

            data.push(item);

        });

        return data;
    }

}
export default AdminSetpointListUtils;


export { setpointGroupingOptions }